// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__FBIpO","footer":"ChangeClinic_footer__2TujV"};